module.exports = __webpack_public_path__ + "img/jk7.b5888423.png";